import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { IoClose, IoMenu } from "react-icons/io5";

const Sidebar = () => {

  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <>
      <button
        className="md:hidden p-4  md:h-screen sticky top-0 font-bold flex gap-3 items-center  text-[#469B8F] text-2xl bg-slate-200"
        onClick={toggleSidebar}
      >
        <IoMenu className='text-2xl font-bold text-[#469B8F]'/> BLOGS
      </button>
      <div
        className={`fixed top-0 left-0 w-80 bg-slate-200 p-4  z-50 transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 md:static md:block`}
      >
        <h2 className="text-xl font-bold mx-auto pb-3">OUR BLOGS</h2>
        <nav className="space-y-2">
          <Link
            to={"/Blog1"}
            className="block  bg-white hover:bg-[#469B8F] px-5 py-2  text-lg font-roboto rounded rounded-tr-full rounded-br-full"
          >
            Understanding Psychiatry: Breaking Stigma and Building Mental Wellness
          </Link>
          <Link
            to={"/Blog2"}
            className="block  bg-white hover:bg-[#469B8F] px-5 py-2   text-lg font-roboto rounded rounded-tr-full rounded-br-full"
          >
            6 Ways You Can Improve Your Mental Health Today
          </Link>
          <Link
            to={"/Blog3"}
            className="block  bg-white hover:bg-[#469B8F] px-5 py-2  text-lg font-roboto rounded rounded-tr-full rounded-br-full"
          >
            How Diet Affects Mental Health: The Role of Nutrition in Psychiatric Wellness
          </Link>
          <Link
            to={"/Blog4"}
            className="block  bg-white hover:bg-[#469B8F] px-5 py-2  text-lg font-roboto rounded rounded-tr-full rounded-br-full"
          >
            Effective Lifestyle Strategies to Lower the Risk of Dementia and Depression in Older Adults
          </Link>
          <Link
            to={"/Blog5"}
            className="block  bg-white hover:bg-[#469B8F] px-5 py-2   text-lg font-roboto rounded rounded-tr-full rounded-br-full"
          >
            When Technology Takes Control: A Deep Dive into Internet Use Disorders
          </Link>
          <Link
            to={"/Blog6"}
            className="block  bg-white hover:bg-[#469B8F] px-5 py-2  text-lg font-roboto rounded rounded-tr-full rounded-br-full"
          >
            Impact of Climate Change: Understanding and Addressing Mental Health in Psychiatry
          </Link>

        </nav>
      </div> 
    </>
  )
}

export default Sidebar